<script>
    import { t } from "../../../../i18n";

    export let data = {};

    let cities = Object.values(data.monuments);

</script>



<div class="table-responsive">
    <table class="table mb-0">
        <thead class="thead-dark">
        <tr>
            <th></th>
            <th>{$t('monuments.name')}</th>
            <th>{$t('monuments.location')}</th>
            <th>{$t('monuments.docs')}</th>
        </tr>
        </thead>
        <tbody>


        {#each cities as city}
        <tr>
            <td colspan="100%">{city.name}</td>
        </tr>


            {#each city.monuments as monument}
            <tr>
                <td></td>
                <td><a target="_blank" rel="nofollow" href="http://www.google.com/search?q={encodeURI(`${monument.name} ${city.name}`)}">{monument.name}</a></td>
                <td style="text-align: center;">
                    {#if monument.gps}
                        <a href="http://www.google.com/maps/place/{encodeURI(monument.gps)}" target="_blank"><i class="bx bxs-map"></i></a>
                    {/if}
                </td>
                <td style="text-align: center;"><a href="http://www.google.com/search?btnI&sourceid=navclient&hl=en&q={encodeURI(`${monument.name} ${city.name} wikipedia`)}" target="_blank"><i class="bx bx-book-open"></i></a></td>
            </tr>
            {/each}

        {/each}




        </tbody>
    </table>
</div>